import { MMLConnectionType } from "../../Enums/ChoiceEnums";
import { getObject, postObject } from "../ChoiceApi";
import { IMMLSimpleResponse, IMMLAuditPrintInputs, IMMLDeleteKeyInputs, IMMLAuditListInputs, IMMLAuditListItem, IMMLSendTokenInputs, 
    IMMLCreateAccountInputs, IMMLCreateAccountResponse, IMMLKeyListItem, IMMLSendKeyInputs, IMMLCreateKeyOnlyInputs, IMMLCreateKeyOnlyResponse } from "../Models/MMLModel";

export async function KeyList(patientId: number): Promise<IMMLKeyListItem[]|undefined> {
    return await getObject(`api/MMLAdmin/KeyList/${patientId}`);
} 
        
export async function OptOut(patientId: number): Promise<IMMLSimpleResponse|undefined> {
    return await getObject(`api/MMLAdmin/OptOut/${patientId}`);
} 

export async function AuditPrint(payload: IMMLAuditPrintInputs): Promise<IMMLSimpleResponse|undefined> {
    return await postObject("api/MMLAdmin/AuditPrint", payload);
} 

export async function DeleteKey(payload: IMMLDeleteKeyInputs): Promise<IMMLSimpleResponse|undefined> {
    return await postObject("api/MMLAdmin/DeleteKey", payload);
} 

export async function AuditList(payload: IMMLAuditListInputs): Promise<IMMLAuditListItem[]|undefined> {
    return await postObject("api/MMLAdmin/AuditList", payload);
}

export async function SendToken(payload: IMMLSendTokenInputs): Promise<IMMLSimpleResponse|undefined> {
    return await postObject("api/MMLAdmin/SendToken", payload);
} 

export async function SendKey(payload: IMMLSendKeyInputs): Promise<IMMLSimpleResponse|undefined> {
    return await postObject("api/MMLAdmin/SendKey", payload);
} 

export async function CreateAccount(payload: IMMLCreateAccountInputs): Promise<IMMLCreateAccountResponse|undefined> {
    return await postObject("api/MML/CreateAccount", payload);
}

export async function CreateKeyOnly(payload: IMMLCreateKeyOnlyInputs): Promise<IMMLCreateKeyOnlyResponse|undefined> {
    return await postObject("api/MMLAdmin/CreateKeyOnly", payload);
} 

export async function GetConnectionType(patientId: number): Promise<MMLConnectionType|undefined> {
    return await getObject(`api/MML/ConnectionType/${patientId}`);
} 